<template>
<footer class="footer">
  <div class="footer-container">
    <div class="footer-note">
      &copy; 2026 <a href="https://gbappss.co/" class="footer-link">gbappss.co</a>
      This site is not affiliated with WhatsApp or Meta. APKs are from third-party sources for educational use only.
    </div>
    <div class="footer-links">
      <a href="/about-us/" class="footer-link">About</a>
      <span>|</span>
      <a href="/contact/" class="footer-link">Contact</a>
      <span>|</span>
      <a href="/privacy-policy/" class="footer-link">Privacy Policy</a>
      <span>|</span>
      <a href="/terms-and-conditions/" class="footer-link">Terms</a>
      <span>|</span>
      <a href="/disclaimer/" class="footer-link">Disclaimer</a>
      <span>|</span>
      <a href="/dmca/" class="footer-link">DMCA</a>
    </div>
  </div>
</footer>
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="scss" scoped>
.footer {
  background-color: #fff;
  color: #121212;
  padding: 18px 0;
  border-top: 1px solid #e8eef2;
}

@media (max-width: 768px) {
  .footer {
    padding: 12px 0 60px;
  }
}

.footer-container {
  width: 88%;
  max-width: 1100px;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  align-items: center;
  font-size: 12px;
  color: #64748b;
}

.footer-link {
  color: #15803d;
  text-decoration: none;
  font-size: 12px;
}

.footer-link:hover {
  color: #16a34a;
}

.footer-note {
  font-size: 14px;
  line-height: 1.5;
  color: #445;
  max-width: 560px;
}

@media (max-width: 768px) {
  .footer-container {
    flex-direction: column;
    align-items: flex-start;
  }

  .footer-note {
    font-size: 12px;
  }
}
</style>
